<template>
  <div>
    <a-modal :visible="true" title="Edit Customer" width="600px" okText="Save" @cancel="closeModal" @ok="submit" class="addUnitModal">
      <a-spin :spinning="Status === 'saving'">
        <a-form :form="form" class="buisnessUnitTypes"
          ><a-form-item>
            <label> Customer Name:</label>
            <a-input
              v-decorator="[
                'customername',
                { initialValue: Customer.customername, rules: [{ required: true, message: 'Please enter customer name!' }] },
              ]"
            />
          </a-form-item>
          <a-form-item>
            <label> Master Client:</label>
            <a-select
              show-search
              v-decorator="[
                'masterclientid',
                { initialValue: Customer.masterclientid, rules: [{ required: true, message: 'Please select a clent!' }] },
              ]"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option v-for="client in Clients" :value="client.client_id" :key="client.client_id">
                {{ client.client_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EditCustomer',
  props: { resetTable: Function },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'EditCustomerForm' }),
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch('customers/updateOpenModal', '');
    },
    submit() {
      this.form.validateFields((errors, { customername, masterclientid }) => {
        if (!errors) {
          this.$store
            .dispatch(`customers/updateCustomer`, {
              customerid: this.Customer.customerid,
              customername,
              masterclientid,
            })
            .then(() => {
              this.resetTable();
              this.closeModal();
            });
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
  },
  computed: {
    ...mapState({
      Customer: (state) => state.customers.Customer,
      Clients: (state) => state.customers.Clients,
      Status: (state) => state.customers.Status,
    }),
  },
};
</script>
<style lang="scss">
.addUnitModal {
  @mixin form-field {
    background-color: #f0f9ff !important;
    height: calc(1.5em + 1rem);
    border-radius: 0.4rem;
    border: 0 solid #ced4da !important;
    box-shadow: inset 1px 1px 3px rgb(157 193 216 / 50%);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .ant-spin-container {
    & > .ant-input {
      width: 100%;
      min-width: 20px;
      @include form-field();
      margin-bottom: 10px;
    }
    .buisnessUnitTypes {
      .ant-form-item {
        margin-bottom: 10px;
        .ant-form-item-children {
          .ant-select,
          & > .ant-input {
            width: 100%;
            min-width: 20px;
          }
          .ant-select-selection.ant-select-selection--single,
          & > .ant-input {
            @include form-field();
            .ant-select-selection__rendered {
              line-height: 36px;
            }
          }
        }
      }
    }
  }
}
</style>
